/**
 * Judge.me's own review widget collapses its Quality/Comfort/Size attribute-ratings summary
 * behind a "More" button by default (their `jm-custom-answer-list--collapsible` component).
 * We want it fully visible on load, on both mobile and desktop, without the customer having to
 * click anything. Since it's a Vue-driven component (its expanded state isn't just a CSS class),
 * the reliable way to open it is to trigger its own toggle rather than fight its internal state
 * with CSS.
 *
 * The widget mounts asynchronously (and can re-render per product/section), so this watches for
 * the button rather than assuming it exists at page load, and keeps watching for a while in case
 * more reviews/instances load in later.
 */
(function () {
  function expandAll() {
    document
      .querySelectorAll('.jm-custom-answer-list__expand-button[aria-expanded="false"]')
      .forEach(function (btn) {
        btn.click();
      });
  }

  expandAll();

  var observer = new MutationObserver(expandAll);
  observer.observe(document.body, { childList: true, subtree: true });

  // Stop watching after a while so it isn't running indefinitely on every page.
  window.setTimeout(function () {
    observer.disconnect();
  }, 15000);
})();
